import { AnyAction, combineReducers, Reducer } from '@reduxjs/toolkit';

import agencyDocuments from './agency-documents';
import agencyInspectorsProfiles from './agency-inspectors-profiles';
import agencyInvoicesList from './agency-invoices-list';
import agencyLeads from './agency-leads';
import agencyOnboarding from './agency-onboarding';
import agencyPayoutsList from './agency-payouts-list';
import agencyReports from './agency-reports';
import agencyReportsList from './agency-reports-list';
import agencyReviews from './agency-reviews';
import auth from './auth';
import clientBookings from './client-bookings';
import clientCompany from './client-company';
import clientInvoicesList from './client-invoices-list';
import clientJobs from './client-jobs';
import clientOnboarding from './client-onboarding';
import clientPaymentsList from './client-payments-list';
import clientReports from './client-reports';
import constants from './constants';
import csvReports from './csv-reports';
import dcraInspectionEvents from './dcra-inspections/inspection-events';
import inspections from './dcra-inspections/inspections';
import inspectors from './dcra-inspections/inspectors';
import inspectorsAvailability from './dcra-inspections/inspectors-availability';
import emailVerification from './email-verification';
import employees from './employees';
import inspectionEvents from './inspection-events';
import invitations from './invitations';
import merchantAccounts from './merchant-accounts';
import messaging from './messaging';
import ui from './ui';

const combinedReducer = combineReducers({
  agencyDocuments,
  agencyLeads,
  agencyOnboarding,
  agencyInspectorsProfiles,
  agencyInvoicesList,
  agencyReportsList,
  agencyPayoutsList,
  agencyReports,
  // agencyStaff,
  // agencySpecialStaff,
  agencyReviews,
  auth,
  clientBookings,
  clientCompany,
  invitations,
  clientJobs,
  clientOnboarding,
  clientInvoicesList,
  clientPaymentsList,
  clientReports,
  constants,
  emailVerification,
  employees,
  merchantAccounts,
  messaging,
  ui,
  csvReports,
  inspectorsAvailability,
  inspections,
  inspectors,
  inspectionEvents,
  dcraInspectionEvents,
});

export type RootState = ReturnType<typeof rootReducer>;

const rootReducer: Reducer = (state: RootState, action: AnyAction) => {
  if (action.type === 'auth/logout') {
    state = {} as RootState;
  }
  return combinedReducer(state, action);
};

export default rootReducer;
